import * as XLSX from "xlsx";
import React, { useState, useRef, useEffect, useMemo, forwardRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format } from "date-fns";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useTable, useGlobalFilter, useSortBy } from "react-table";
import { GrFormSearch } from "react-icons/gr";
import { COLUMNS } from "../function-components/LearningCalendar/Columns";
import AdminPage from "../function-components/LearningCalendar/AdminPage";
import TablePagination from "@mui/material/TablePagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import FilterModal from "../function-components/LKMCalendarNew/FilterModal";
import "./Home.css";

const HomeNew = () => {
  const [data, setData] = useState([]);
  const [dataNew, setDataNew] = useState([]);
  const [loader, setLoader] = useState(false);
  const [inputChange, setInputChange] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterCriteria, setFilterCriteria] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [currentFilterColumn, setCurrentFilterColumn] = useState("");
  const [uniqueColumnData, setUniqueColumnData] = useState([]);
  const [date, setDate] = useState(new Date());
  const [pageUpdate, setPageUpdate] = useState(false);
  const [downloadedFileName, setDownloadedFileName] = useState('');
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [resetTableData, setResetTableData] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [searchEvent, setSearchEvent] = useState('');
  const [checkboxData, setCheckBoxData] = useState([]);
  const [modeOfDelivery, setModeOfDelivery] = useState(true);
  const [selectedValues, setSelectedValues] = useState({
    CourseName: [],
    SessionStartDate: [],
    ModeofDelivery: [],
    Capability: [],
    Category: [],
    TargetAudienceLevel: []
  });

  function addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    console.log(date, "datee in add months")
    return date;
  }

  const currDate = new Date();
  const currEndDate = addMonths(new Date(), 2);

  const [startDate, setStartDate] = useState(Moment(new Date()).startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(Moment(currEndDate).endOf("month").format("YYYY-MM-DD"));

  const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <button className="date-picker-input-btn" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));
  const handleStartDate = (date) => {
    // setFromStartDate(date);
    // let startDate = Moment(date).format("YYYY-MM-DD");
    setStartDate(Moment(date).startOf("month").format("YYYY-MM-DD"));
    // console.log(startDate, 'startdateee')

    setDate(date);
    // selectedMonth = format(date, "MM");
    // setMonth(selectedMonth);
    // selectedYear = format(date, "yyyy");
    // setYear(selectedYear);
    // console.log(date,"startdate",endDate,"endDate")
    fetchFilteredAPI(Moment(date).startOf("month").format("YYYY-MM-DD"), endDate);
    // fetchData(selectedMonth.toLocaleLowerCase(), selectedYear);
    setPageNumber(0);
  };

  const handleEndDate = (date) => {
    console.log(date, 'date in handleEndDate')
    // setToEndDate(date);
    // setStartDate(Moment(fromStartDate).format("YYYY-MM-DD"));
    // setStartDate(Moment(date).startOf("month").format("YYYY-MM-DD"));
    setEndDate(Moment(date).endOf("month").format("YYYY-MM-DD"));
    // console.log(endDate, 'endDateee')
    const tempEndDate = Moment(date).endOf("month").format("YYYY-MM-DD");

    fetchFilteredAPI(startDate, tempEndDate);
    setPageNumber(0);
  };

  useEffect(() => {
    setStartDate(Moment(startDate).format("YYYY-MM-DD"));
    // console.log(startDate, 'startdateee')
    setDate(startDate);
    const tempStartDate = Moment(startDate).startOf("month").format("YYYY-MM-DD");
    // selectedMonth = format(date, "MM");
    // setMonth(selectedMonth);
    // selectedYear = format(date, "yyyy");
    // setYear(selectedYear);

    setEndDate(Moment(endDate).format("YYYY-MM-DD"));
    // console.log(endDate, 'endDateee')
    const tempEndDate = Moment(endDate).endOf("month").format("YYYY-MM-DD");

    console.log(tempStartDate, tempEndDate, "ON FIRST RENDER");
    setTimeout(() => {
      fetchFilteredAPI(tempStartDate, tempEndDate);
    }, [1000])
    console.log("data fetched")
  }, [pageUpdate, startDate, endDate])

  useEffect(() => {
    fetchFilteredAPI(startDate, endDate);
  }, []);

  
  const fetchFilteredAPI = async (startDate, endDate) => {
    // console.log(startDate, endDate, 'starttttendDateee in filterdfd')
    // console.log(urltemp, "urltempppppp");
    try {
      let res = await axios({
        method: "get",
        url: `https://atci.lkm.accenture.com/LKM-Calendar-Apis/fetchCalendarData/${startDate}/${endDate}`,
        headers: {
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        },

        // url: `https://atci.lkm.accenture.com/LKM-Calendar-Apis/fetchCalendarData/2023-09-01/2023-09-30`,
        // url: `http://localhost:3002/fetchCalendarData/${startDate}/${endDate}`,
      });
      setLoader(false)
      setData(res.data.map((item, i) => ({ ...item, SessionStartDate: item.SessionStartDate.slice(0, 10), SessionEndDate: item.SessionEndDate.slice(0, 10), SId: i + 1 })));
      console.log(res.data, "res.dataa");
      setDataNew(res.data.map((item, i) => ({ ...item, SessionStartDate: item.SessionStartDate.slice(0, 10), SessionEndDate: item.SessionEndDate.slice(0, 10), SId: i + 1 })));
      setDownloadedFileName(`LKM_Calendar_Data.xlsx`);
      setModeOfDelivery(true);
    } catch (error) {
      setLoader(false)
      setData([]);
    }
  };

  const noData = data.length === 0;

  const downloadExcel = () => {
    let downloadData = [];
    data.map((item) => {
      let { UId, ...xyz } = item;
      downloadData.push(xyz);
    });
    downloadData.map((item, i) =>
      ({ ...item, SId: i + 1 })
    )


    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(downloadData);
    XLSX.utils.decode_cell({});
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.utils.decode_cell(ws);
    XLSX.writeFile(wb, downloadedFileName);
  };



  const filteredData = useMemo(() => {
    if (Object.keys(filterCriteria).length === 0) {
      // If no filters, return the original data
      return [...data]; // Ensure a new array is returned to trigger updates
    }

    return data.filter((row) =>
      Object.entries(filterCriteria).every(([key, values]) => {
        if (!values || values.length === 0) return true; // Allow all values if no filter is applied
        return values.includes(row[key]);
      })
    );
  }, [data, filterCriteria]);




  const handleFilterClick = (column) => {
    setCurrentFilterColumn(column);
    setUniqueColumnData([...new Set(dataNew.map((item) => item[column]))]);
    setIsFilterModalOpen(true);
  };

  const applyFilter = (column, selectedValues) => {
    console.log(selectedValues, "selected valuess")
    setFilterCriteria((prev) => {
      const updatedCriteria = { ...prev };
      console.log(prev, "prevv")

      // Update the filter criteria for the current column
      if (selectedValues[column]?.length > 0) {
        updatedCriteria[column] = selectedValues[column];
      } else {
        delete updatedCriteria[column]; // Remove the filter if no values are selected
      }
      console.log(updatedCriteria, "updated criteriaa")
      // Recalculate the filtered data starting from the main dataset
      const recalculatedData = Object.entries(updatedCriteria).reduce((filtered, [key, values]) => {
        if (values && values.length > 0) {
          return filtered.filter((row) => values.includes(row[key]));
        }
        return filtered; // If no values are checked for this column, skip filtering
      }, dataNew);

      // Update the data state and filter criteria
      setData(recalculatedData);
      return updatedCriteria;
    });

    setIsFilterModalOpen(false); // Close the modal after applying filters
  };
  console.log(data, "dataaa")





  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };

  const handlePageChange = (event, newPage) => {
    setPageNumber(newPage);
  };

  const formHandler = (e) => {
    e.preventDefault();
  };

  const globalSearch = (e) => {
    const inputVal = e.target.value;
    setInputChange(inputVal);
    if (inputVal !== "") {
      const filteredData = dataNew.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(inputVal.toLowerCase());
      });
      setData(filteredData);
    } else {
      setData(dataNew);
    }
    setPageNumber(0);
  };

  // const columns = useMemo(() => COLUMNS, [data]);
  const columns = COLUMNS;
  const tableInstance = useTable(
    { columns, data: filteredData },
    useGlobalFilter,
    useSortBy
  );
  const { getTableProps, getTableBodyProps, headerGroups } = tableInstance;

  const DATA = filteredData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);

  const tableRestBtn = () => {
    setResetTableData(true)
    setSearchEvent('');
    setSearchData([]);
    setCheckBoxData(checkboxData.map((elem) => {
      return { ...elem, isChecked: true };
    }))
    setStartDate(Moment(currDate).startOf("month").format("YYYY-MM-DD"));
    setEndDate(Moment(currEndDate).startOf("month").format("YYYY-MM-DD"));
    setPageNumber(0);
    setInputChange("");
    setFilterCriteria({});
    setData([...dataNew])
    setSelectedValues({
      CourseName: [],
      SessionStartDate: [],
      ModeofDelivery: [],
      Capability: [],
      Category: [],
      TargetAudienceLevel: []
    });
  }

  const tableData = (row, index) => (
    <tr key={index}>
      <td>{row.SId}</td>
      <td>{row.CourseName}</td>
      <td>{row.SessionStartDate}</td>
      <td>{row.SessionEndDate}</td>
      <td>{row.Duration}</td>
      <td>{row.ModeofDelivery}</td>
      <td>{row.Capability}</td>
      <td>{row.Category}</td>
      <td>
        <a href={row.MyLearningSessionLink}>Register</a>
      </td>
      <td>{row.TargetAudienceLevel}</td>
    </tr>
  );

  return (
    <>
      {console.log(data, "dataaaaaaaaaaaa")}
      <div ref={ref} style={{ position: "relative" }}>
        <AdminPage setCalendar={setShow} setPageUpdate={setPageUpdate}></AdminPage>
      </div>
      <div className="main_container">
        <div className="reset-container">
          <div className='reset-table-data' onClick={tableRestBtn}>Reset</div>
        </div>
        <div className="sub-container">
          <form onSubmit={formHandler} id="form_container">
            <div className="download-search-wrapper">
              <span
                onClick={downloadExcel}
                className="download-btn"
                title="Download Excel"
                disabled={noData}
              >
                &#x2913; Download
              </span>
              <div className="searchWrap">
                <div className="search-icon">
                  <span className="search-image">
                    <GrFormSearch />
                  </span>
                  <input
                    type="search"
                    id="search"
                    placeholder="Search..."
                    onChange={globalSearch}
                    autoComplete={false}
                    disabled={noData ? false : false}
                    value={inputChange}
                  />
                </div>
              </div>
            </div>

            <div className="date-picker-container">
              <span className="filter-text">Select Month | &nbsp;</span>
              <div className="date-picker-start">
                <DatePicker
                  selected={new Date(startDate)}
                  onChange={(date) => handleStartDate(date)}
                  // minDate={new Date("2022/01/01")}
                  minDate={new Date()}
                  maxDate={new Date(endDate)}
                  showMonthYearPicker
                  dateFormat="MMM-yyyy"
                  customInput={<DatePickerInput />}
                />
              </div>
              <span className="filter-text"> &nbsp;&nbsp;to&nbsp;&nbsp; </span>
              <div className="date-picker-end">
                <DatePicker
                  selected={new Date(endDate)}
                  onChange={(date) => handleEndDate(date)}
                  minDate={new Date(startDate)}
                  maxDate={new Date(Moment(addMonths(new Date(), 12)).endOf("month").format("YYYY-MM-DD"))}
                  showMonthYearPicker
                  dateFormat="MMM-yyyy"
                  customInput={<DatePickerInput />}
                />
              </div>
            </div>
            {console.log(data, "data before pagination")}
            {filteredData.length > 0 && (
              <TablePagination
                component="div"
                count={filteredData.length}
                page={pageNumber}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </form>
        </div>



        <div className="tableResponsive">
          <table {...getTableProps()} className="mytable">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th key={column.id} style={{ width: column.width }}>
                      <div className="header-wrapper">
                        <span {...column.getHeaderProps()}>
                          {column.render("Header")}
                        </span>
                        {[
                          "CourseName",
                          "SessionStartDate",
                          "ModeofDelivery",
                          "Capability",
                          "Category",
                          "TargetAudienceLevel",
                        ].includes(column.id) && (
                            <p
                              className="filter-icon"
                              onClick={() => handleFilterClick(column.id)}
                              title="Filter"
                            >
                              {/* &#x25BC; */}
                              {column.Img}
                            </p>
                          )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {loader ? (
                <tr>
                  <td colSpan={10}>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </td>
                </tr>
              ) : DATA.length === 0 ? (
                <tr>
                  <td colSpan={10}>No data to display!</td>
                </tr>
              ) : (
                DATA.map((row, index) => tableData(row, index))
              )}
            </tbody>
          </table>
        </div>
        {filteredData.length > 0 && (
          <TablePagination
            component="div"
            count={filteredData.length}
            page={pageNumber}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        columnData={uniqueColumnData}
        columnName={currentFilterColumn}
        applyFilter={applyFilter}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
      />
    </>
  );
};

export default HomeNew;
